<template>
   <div class="frame-child">
    <iframe v-if="!scroll" scrolling="no" class="iframe-scroll "  :src="url" target="_parent" :frameBorder="length>1?1:0" allowfullscreen></iframe>
    <iframe v-if="scroll"  class="iframe"  :src="url" target="_parent" :frameBorder="length > 1 ? 1:0" allowfullscreen></iframe>
  </div>
</template>

<script>
import URI from 'urijs';
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import conf from '@/config/config';
export default {
  name: 'Url',
  props: ['pageParams'],
  data() {
    return {
      url: '',
      scroll: false,
      dark:false,
      item: {},
      length: null,
      eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
      },
       webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
      },
      error: true,
      timeout: 0,
      mmsReady: false,
      mms: null
    };
  },
  async created() {
    //let urlps = new URL(window.location).searchParams;
    let pageParams = Object.assign({}, this.pageParams);
    let url = pageParams.url.replace("watch?v=", "embed/");
    if(pageParams.dark !=undefined)
    this.dark=pageParams.dark;
    this.scroll = pageParams.scroll;
    this.length = pageParams.length;
    this.item = pageParams.item;
    delete pageParams.url
    delete pageParams.item
    delete pageParams.scroll
    delete pageParams.length
    // let otherParams = {};
    // pageParams.forEach((value, key) => {
    //     otherParams[key] = value;
    // })
    let newUrl = URI(url).addSearch({output: "embed"}).addSearch(pageParams);
    this.url = newUrl.toString();
    console.log(this.url);
    this.startMMS();
    //await this.track(this.mms, 'url');
  },
  async beforeMount() {
     await this.subscribeMMS();
  },
  beforeDestroy() {
      this.removeEvent();
  },
  methods: {
    startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("url-EiToken") || "",
            SToken: getCookie("url-SToken") || ""
          });
      },
      async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'pgURL' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("url-EiToken", this.webmmsOptions.EiToken);
             setCookie("url-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             this.mmsReady = true;
             this.error = false;
             let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
             let result = await this.mms.setDeviceInfo(deviceInfo);
             console.log('SetDevice reply=%s', JSON.stringify(result));
             await this.track(this.mms, 'url', this.pageParams);
        });

        this.mms.on('message', (method, from, data, retcb) => {
              this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if ( typeof retcb == 'function') retcb({"ErrCode":0, "ErrMsg":"OK"})
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      }
  }
};
</script>

<style lang="sass">
.Url
  +ab_start
  +size(100%, 100%)
  -webkit-overflow-scrolling: touch
  overflow-y: auto
  iframe
    z-index: 9999
</style>
<style lang="scss" scoped>
.iframe-noborder {
  border: 0px none transparent;
}
.frame {
 /*border: 1px solid #dbd7d7;
  overflow: hidden;
  box-shadow: 4px 5px 7px 1px #bdbcbc;*/
}

.frame-child{
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.frame .iframe-scroll {
  height: 100%;
  width: 100%;
}

.frame iframe {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.frame iframe html{
  overflow: hidden;
}
</style>
